import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const here=window.location

//
// If the URL is localhost or numeric (not looked up in DNS) we assume that this
// is running in development mode and redirect to a test page
//

let DEV_HOSTNAME = /^(localhost|[0-9.]+)$/i

if(here.hostname.match(DEV_HOSTNAME)) {
    if(!here.pathname.startsWith("/$/")) {
        here.pathname = "/$/3TK$LMS0TFPT7JGCY/"
    }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

